// tslint:disable-next-line
export const WS_URL = process.env['WS_URL'] || `ws://${location.hostname}:5000`;
export const HTTP_URL = WS_URL.replace(/^ws/, 'http');